import { Component, OnInit, ViewChild,HostListener } from '@angular/core';
import { HelperService } from '../helper.service';
import { Subject } from 'rxjs/Subject';
import { Http, Response,Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { DataTableDirective } from 'angular-datatables';
import {MatSnackBar} from '@angular/material';
import { NgForm } from '@angular/forms';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {SnackbarComponent} from '../snackbar/snackbar.component';

class Data {
  id: number=0;
  name: string='';

}
@Component({
  selector: 'app-grades',
  templateUrl: './grades.component.html',
  styleUrls: ['./grades.component.css'],
  providers: [HelperService] 
})

export class GradesComponent implements OnInit {
  // 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }
  @ViewChild(DataTableDirective)

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  datas: Data[] = [];
  dtElement: DataTableDirective;

  list=true;
  edit=false;
  add=false;
  icon=this.helper.add_icon;
  icon_action='addClick';
  all:any=[];
  selected:any=[];
  grade_id=0;
  grade_name='';
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  constructor(private helper:HelperService,private http:Http,private snackbar: MatSnackBar,private activatedRouter:ActivatedRoute,private router:Router) {
    
  }

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    };
    
    this.http.get(this.helper.base_url+'http/get/grades',{ headers: this.headers })
      .map(this.extractData)
      .subscribe(data => {
        this.datas = data;
        
          this.dtTrigger.next();
        
       
      });
  }
  

  
  addClick(e){
    this.http.get(this.helper.base_url+'http/get/subjects/'+this.grade_id,{ headers: this.headers })
      .subscribe(
         
          (data) => {
            this.selected=JSON.parse(data.text())['data'][1]
            this.all=JSON.parse(data.text())['data'][0];
           
            // this.refresh();
          }, //For Success Response
          err => {console.error(err)} //For Error Response
      );
    this.list=false;
    this.edit=false;
    this.add=true;
    this.icon=this.helper.list_icon;
    
    this.icon_action="listClick";
  }
  listClick(e){
    this.list=true;
    this.edit=false;
    this.add=false;
    this.icon=this.helper.add_icon;
    this.icon_action="addClick";
  }
   editClick(id,name){
    this.list=false;
    this.edit=true;
    this.add=false;
    this.icon=this.helper.list_icon;
    this.icon_action="listClick";
    this.grade_name=name;
    this.grade_id=id;
  }
  deleteClick(id){
  
    let snackBarRef = this.snackbar.openFromComponent(SnackbarComponent, {
      //this.snackbar.open('Are you sure!', 'Delete', {
        duration: 10000,
        extraClasses:  ['warning-snackbar'],
      });
      snackBarRef.onAction().subscribe(() => {
        this.http.get(this.helper.base_url+'http/delete/grades/'+id,{ headers: this.headers })
        .subscribe(
           
            (data) => this.refresh(false,'Grade Removed successfully'), //For Success Response
            err => {console.error(err)} //For Error Response
        );   
      });
  }


 refresh(val=false,msg=''){
   
  this.snackbar.open(msg, null, {
    duration:5000,
      extraClasses:'success-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["grades"]));
      
 }
 add_form(addForm: NgForm){
  let body = new FormData();
  body.append('name', addForm.value.name);

   this.http.post(this.helper.base_url+'http/add/grades', body,{ headers: this.headers })
   .subscribe(
     (res) => {
      this.listClick(null) ;
      this.refresh(false,'Grade added successfully') ;
     }, //For Success Response
      err => {console.error(err)} //For Error Response);
   );
 }

update_form(updateForm: NgForm){
  let id =this.grade_id;
 let body = new FormData();
 
 body.append('name', updateForm.value.name);

  this.http.post(this.helper.base_url+'http/update/grades/'+id, body,{ headers: this.headers })
  .subscribe(
    (res) => {
     this.listClick(null) ;
     this.refresh(false,'Grade updated successfully') ;
    }, //For Success Response
     err => {console.error(err)} //For Error Response);
  );
}

  private extractData(res: Response) {
    const body = res.json();
    return body.data || {};
  }

}



// WEBPACK FOOTER //
// ./src/app/grades/grades.component.ts